import { Component, Inject, Input, OnInit } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface DialogData {
  image_list: any[];
  image_index: number;
}

@Component({
  selector: "app-gallery",
  templateUrl: "./gallery.component.html",
  styleUrls: ["./gallery.component.css"],
})
export class GalleryComponent implements OnInit {
  constructor(public dialog: MatDialog) {}
  @Input() images!: any[];

  src_img!: string;
  image_index: number = 0;

  image_list!: any[];
  ngOnInit(): void {
    this.image_list = this.images.map((x) => x.image_url);
    this.fnShow(this.image_index);
  }

  fnShow(_image_index: number) {
    this.image_index = _image_index;
    this.src_img = this.image_list[this.image_index];
  }

  openDialog() {
    this.dialog.open(GalleryZoom, {
      width: "120%",
      height: "98%",
      data: {
        image_list: this.image_list,
        image_index: this.image_index,
      },
    });
  }
}

@Component({
  selector: "gallery-zoom",
  templateUrl: "./gallery-zoom.component.html",
  styleUrls: ["./gallery.component.css"],
})
export class GalleryZoom {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  fnBack(_image_index: number) {
    const _length = this.data.image_list.length;
    if (_image_index > 0) {
      this.data.image_index = _image_index - 1;
    } else {
      this.data.image_index = _image_index = _length - 1;
    }
  }

  fnNext(_image_index: number) {
    const _length = this.data.image_list.length;
    if (_image_index + 1 < _length) {
      this.data.image_index = _image_index + 1;
    } else {
      this.data.image_index = _image_index = 0;
    }
  }
}
